var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('viewer-360',{attrs:{"rows":3,"cols":12,"imagePath":_vm.imagePath,"fileName":"img_0_{row}_{col}.jpg?v1"}})}
var staticRenderFns = []

export { render, staticRenderFns }